import { Component } from '@ecs/Component';

export class HealthDisplay implements Component {
  readonly type = 'HealthDisplay';
  
  constructor(
    public showHealthBar: boolean = false,
    public healthPercentage: number = 1,
    public barColor: string = '#00ff00',
    public barWidth: number = 30,
    public barHeight: number = 4,
    public barOffset: number = 20
  ) {}
}